import { render, staticRenderFns } from "./ClientServiceUsers.vue?vue&type=template&id=0381e3fc&scoped=true"
import script from "./ClientServiceUsers.vue?vue&type=script&lang=js"
export * from "./ClientServiceUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381e3fc",
  null
  
)

export default component.exports